import { Row, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useChangelogParams } from '../../../changelogRouteUtil'

export default function ContributionsActionBarSkeleton(): JSX.Element {
  const { relationshipId } = useChangelogParams()

  return (
    <Row alignY="middle" guttersX="sm">
      <Skeleton.Paragraph maxWidth={150} size="md" />

      <div growX />
      {!relationshipId && <Skeleton.Button emphasis="medium" minWidth={100} data-testid="filter-button-skeleton" />}
    </Row>
  )
}
